// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"styles_scrollable__2U5w3","alwaysScrollable":"styles_alwaysScrollable__83xwU styles_scrollable__2U5w3"};